
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createForms } from 'react-redux-form';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { User } from './user';
import { AssetSeries } from './asset_series';
import { OptimSaa, SaaMetrics, SaaExposure } from './optim_saa';
import { PortMetricsCompar, PortMetricsTactical, PortBacktest } from './metrics';
import { FundsSelect } from './funds';
import { InitialCatalog, InitialParams, InitialClientParams, InitialBacktestParams, InitialBuilderParams,
         InitialComparParams, InitialTacticalParams, InitialSuitParams, InitialLoadParams,
         InitialSignatureParams, InitialFundParams } from './forms';

const appReducer = combineReducers({
    user_wm:User,
    asset_series:AssetSeries,
    optim_saa:OptimSaa,
    optim_port_metrics: SaaMetrics,
    optim_port_exposure: SaaExposure,
    funds:FundsSelect,
    ...createForms({
        catalog:InitialCatalog,
        port_metrics:PortBacktest,
        port_metrics_compar:PortMetricsCompar,
        port_alloc_backtest:null,
        port_alloc_compar:null,
        port_metrics_tactical:PortMetricsTactical,
        builder_port_metrics:null,
        builder_port_exposure:null,
        builder_params:InitialBuilderParams,
        port_form_builder: new Array(5).fill({manager:'', name:'', benchmark:"", value:0, weight:0}),
        optim_params: InitialParams,
        optim_cons:{assetcons:null, groupcons:null},
        assets_summ:null,
        backtest_params: InitialBacktestParams,
        compar_params: InitialComparParams,
        tactical_params: InitialTacticalParams,
        signature_params: InitialSignatureParams,
        port_groups: null,
        bench_name:null,
        asset_tks_list:[],
        optim_curr:'USD',
        asset_series_range:'10Y',
        port_name_metrics:null,
        bench_name_metrics:null,
        fx_metrics:"USD",
        chat_market_view:[],
        question_market_view:null,
        llm_market_view_topic:["committee_global"],
        date_market_view:(new Date()).toISOString().slice(0,7),
        fund_params:InitialFundParams,
        client_params:InitialClientParams,
        client_portfolio:null,
        client_port_exposure:null,
        client_port_metrics:null,
        client_port_backtest:null,
        client_port_exposure_trades:null,
        client_port_metrics_trades:null,
        client_performance:null,
        client_trades:[],
        suit_params:InitialSuitParams,
        load_params:InitialLoadParams,
        report_analysis:null,
        file_dl:''
    })
});

// On USER_LOGOUt we pass an undefined state to reset store. 
const rootReducer = (state, action) => {
  if (action.type === 'USER_SIGNOUT') {
    // Clean storage to avoid rehydrate
    storage.removeItem('persist:root')
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

const persistConfig = {
    key: 'root',
    storage,
    debug: false
}

const persistedReducers = persistReducer(persistConfig, rootReducer);
export const ConfigureStore = () => {
    const store = createStore(
        persistedReducers,
        applyMiddleware(thunk, logger) //enhancer
    );
    
    const persistor = persistStore(store);
    return { persistor, store };
};
